export default {
    attachment: "/gateway/huilianApi/uploader/attachment", // 图片上传
    h5: {
        businessLicenseOCR:
            "/gateway/huilianCust/realCustcs/businessLicenseOCR", //营业执照OCR识别
    },
    wechat: {
        businessLicenseOCR:
            "/gateway/huilianCust/realCustcs/businessLicenseOCR", //营业执照OCR识别
    },
};



// WEBPACK FOOTER //
// ./src/authCertificate/modules/papersUpload_QY/api.js